/**
 * @file getArrowColor.js
 * @description Utility function that determines the color of wind direction arrows
 * based on wind speed values. The color intensity increases with wind speed,
 * providing a visual indication of wind strength.
 */

import { colorRanges } from "../components/WeatherDashboard/colorRanges";

/**
 * Determines the appropriate color for a wind direction arrow based on wind speed
 * @param {number} speed - Wind speed value
 * @returns {string} RGB color string representing the arrow color
 *
 * @example
 * const arrowColor = getArrowColor(15); // Returns RGB color for 15 km/h wind speed
 */
const getArrowColor = (speed) => {
  for (let i = colorRanges.length - 1; i >= 0; i--) {
    if (speed >= colorRanges[i][0]) {
      const [r, g, b] = colorRanges[i][1];
      return `rgb(${r}, ${g}, ${b})`;
    }
  }

  // Default to black if no match
  return "rgb(0 ,0 ,0)";
};

export default getArrowColor;
